import React, { useState, useCallback } from "react";
import axios from "axios";
import { useDropzone } from "react-dropzone";
import upload from "../assets/upload.png";

const API_BASE_URL = process.env.REACT_APP_NODE_API_BASE_URL || process.env.REACT_APP_API_BASE_URL;

const JudgeView = () => {
  const [file, setFile] = useState(null);
  const [pdfUrl, setPdfUrl] = useState(null);

  const onDrop = useCallback((acceptedFiles) => {
    setFile(acceptedFiles[0]);
    setPdfUrl(URL.createObjectURL(acceptedFiles[0]));
  }, []);

  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  const handleUpload = async () => {
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);
    formData.append("email", localStorage.getItem("email"));
    console.log(formData.get("email"));

    try {
      const { data } = await axios.post(
        `${API_BASE_URL}/api/pdf/upload`,
        formData
      );
      console.log(data);
    } catch (error) {
      console.error("Upload failed:", error);
    }
  };

  return (
    <div className="flex h-[92vh] bg-white p-5 gap-5">
      <div className="flex-1 flex flex-col gap-5">
        <h2 className="text-4xl font-bold text-gray-800">Client Upload</h2>
        <div
          {...getRootProps()}
          className="border-2 border-dashed border-orange-500 rounded-3xl p-10 text-center flex flex-col items-center justify-center"
        >
          <input {...getInputProps()} />
          <img src={upload} alt="Upload" className="w-12 mb-3" />
          <p className="text-gray-600">Drag and Drop files to upload</p>
          <p className="text-gray-600 my-1">or</p>
          <button className="px-5 py-2 bg-gradient-to-r from-orange-400 to-orange-600 text-white rounded-full cursor-pointer hover:from-orange-500 hover:to-orange-700 transition-all duration-200 ease-in-out">
            Browse
          </button>
        </div>
        <div className="flex gap-3">
          <button
            onClick={handleUpload}
            className="flex-1 py-2 bg-gradient-to-r from-orange-400 to-orange-600 text-white rounded-full cursor-pointer hover:from-orange-500 hover:to-orange-700 transition-all duration-200 ease-in-out"
          >
            Upload
          </button>
          <button className="flex-1 py-2 bg-white border-2 border-orange-500 text-orange-500 rounded-full cursor-pointer hover:bg-orange-50 transition-colors duration-200 ease-in-out">
            Review
          </button>
        </div>
      </div>
      <div className="flex-1 relative rounded-3xl overflow-hidden">
        <div className="absolute -bottom-12 -left-12 w-52 h-52 bg-gradient-to-r from-orange-400 to-orange-600 opacity-30 rounded-full"></div>
        <div className="relative bg-white rounded-3xl h-full shadow-lg z-10 flex flex-col overflow-hidden border border-gray-200">
          <div className="bg-gradient-to-r from-orange-400 to-orange-600 p-5">
            <h3 className="text-white text-xl font-medium">Document Viewer</h3>
          </div>
          <div className="flex-1 p-5 overflow-auto">
            {pdfUrl ? (
              <iframe
                src={pdfUrl}
                className="w-full h-full border-none rounded-lg"
                title="PDF Viewer"
              />
            ) : (
              <p className="text-gray-600 text-center">
                No document uploaded yet.
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default JudgeView;
